/** Individual route path strings – single source of truth used by childRoutes,
 *  AppRouteGuard, and VALID_ROUTES / CONTENT_ROUTES sets below. */
export const ROUTE_ROOT = '/';
export const ROUTE_TABLE = '/table';
export const ROUTE_WELCOME = '/welcome';
export const ROUTE_ERROR = '/error';
export const ROUTE_NOT_FOUND = '/notFound';
export const ROUTE_ANY = '*';
/** Catch-all pattern matched by the router for any unrecognised URL. */
export const ROUTE_CATCH_ALL = '*';

/** All recognised application paths. AppRouteGuard Phase 2 validates against this. */
export const VALID_ROUTES = new Set([
  ROUTE_ROOT,
  ROUTE_TABLE,
  ROUTE_WELCOME,
  ROUTE_ERROR,
  ROUTE_NOT_FOUND,
]);

/** Routes that require dashboard data in the Redux store to render. */
export const CONTENT_ROUTES = new Set([ROUTE_TABLE, ROUTE_WELCOME]);

/** API `next_view` value that routes to the permissions table. */
export const REPEATED_USER = 'REPEATED_USER';

// ── Country / locale constants ───────────────────────────────────────────────
export const COUNTRY_CODES = Object.freeze({
  GB: 'GB',
  IE: 'IE',
  DE: 'DE',
});

export const LOCALES = Object.freeze({
  EN_GB: 'en_GB',
  EN_IE: 'en_IE',
  DE_DE: 'de_DE',
});

export const ACTION_VRP = 'vrp';
export const NEXT_VIEW_VRP_UPDATE = 'VRP_UPDATE';

export const BUTTON_TYPE_CUSTOM = 'custom';

export const ALPHA_NUMERIC_CHAR_LEN = 32;
export const ALPHA_NUMERIC_CHAR = 'abcdefghijklmnopqrstuvwxyz0123456789';
export const AAT = 'aat';

export const DASHBOARD_ROOT = 'axp-bank-permissions-dashboard-root';
export const GATEWAY_APP_CONFIG_URL = 'vrpDashboardApiUrl';
export const READ_USER_SESSION_URL = 'readUserSessionUrl';
export const STORE_CONFIG = 'config';
export const STORE_MODULES = 'modules';
export const STORE_DASHBOARD = 'dashboard';

export const X_PWB_JWT_TOKEN = 'xPwbJwtToken';
export const TRACKING_ID = 'trackingId';
